import createNumberMask from 'text-mask-addons/dist/createNumberMask';
import memoize from 'lodash/memoize';
import { DATEPICKER_FORMATS } from '../components/atoms/Datepicker/types';
// @todo: just reserved mock for future usage, extra naive!!!
function makeMaskFromString(string) {
    return string.split('').map(function (char) {
        return char === '9' ? /\d/ : char;
    });
}
export var inputMasks = {
    getCurrencyMask: memoize(function () {
        return createNumberMask({
            prefix: '',
            suffix: '',
            includeThousandsSeparator: true,
            thousandsSeparatorSymbol: '.',
            allowDecimal: false,
            allowNegative: false,
            allowLeadingZeroes: true,
        });
    }),
    getFloatNumberMask: memoize(function () {
        return createNumberMask({
            prefix: '',
            suffix: '',
            includeThousandsSeparator: true,
            thousandsSeparatorSymbol: '.',
            allowNegative: false,
            allowLeadingZeroes: true,
            allowDecimal: true,
            decimalSymbol: ',',
        });
    }),
    getPostalCodeMask: memoize(function () {
        return createNumberMask({
            prefix: '',
            includeThousandsSeparator: false,
            integerLimit: 5,
            allowDecimal: false,
            allowNegative: false,
            allowLeadingZeroes: true,
        });
    }),
    getYearMask: memoize(function () {
        return createNumberMask({
            prefix: '',
            includeThousandsSeparator: false,
            integerLimit: 4,
            allowDecimal: false,
            allowNegative: false,
            allowLeadingZeroes: true,
        });
    }),
    getDateMask: memoize(function (format) {
        if (format === DATEPICKER_FORMATS.DD_MM_YYYY) {
            return makeMaskFromString('99.99.9999');
        }
        return makeMaskFromString('99.9999');
    }),
};
